"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonLogin = void 0;
const react_1 = __importDefault(require("react"));
const react_hot_toast_1 = require("react-hot-toast");
const styled_components_1 = __importDefault(require("styled-components"));
const ButtonLogin = () => (react_1.default.createElement(BoxLogin, null,
    react_1.default.createElement(LoginButton, { onClick: () => {
            window.location = `https://accounts.fozg.net/signin?continueUrl=${window.location.href}`;
        } },
        react_1.default.createElement(Logo, null),
        " Login via Fozg.net")));
exports.ButtonLogin = ButtonLogin;
function default_1({ isAuthenting }) {
    return (react_1.default.createElement(Screen, null,
        isAuthenting ? "Login..." : react_1.default.createElement(exports.ButtonLogin, null),
        react_1.default.createElement(react_hot_toast_1.Toaster, null)));
}
exports.default = default_1;
const Screen = styled_components_1.default.div `
    height: 100vh;
    width: 100vw;
    background: linear-gradient(
        160deg,
        rgb(237 245 255) 0%,
        rgba(146, 181, 222, 1) 100%
    );
    display: flex;
    align-items: center;
    justify-content: center;
`;
const BoxLogin = styled_components_1.default.div `
    // background-color: rgba(0, 0, 0, 0.1);
    // box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
    padding: 50px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
`;
const LoginButton = styled_components_1.default.div `
    display: inline-block;
    background: #fff;
    border-radius: 20px;
    padding: 10px 20px 10px 10px;
    font-weight: 500;
    display: flex;
    align-items: center;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    :hover {
        background: #f3f3f3;
    }
`;
const Logo = styled_components_1.default.div `
    width: 50px;
    height: 50px;
    background-image: url(https://accounts.fozg.net/images/logo.png);
    background-size: 100%;
    margin-right: 20px;
    border-radius: 10px;
    overflow: hidden;
`;
//# sourceMappingURL=LoginScreen.js.map